import type React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@xing-com/button';
import type { Maybe } from '@xing-com/crate-common-graphql-types';
import { Headline } from '@xing-com/typography';

import * as S from './projobs-upsell-banner.styles';

type RecruiterInfoCardProps = {
  headline: string;
  copy: string;
};

const RecruiterInfoCard: React.FC<RecruiterInfoCardProps> = ({
  headline,
  copy,
}) => {
  return (
    <S.RecruiterInfoCard>
      <Headline size="xxlarge" sizeWide="xxxlarge" noMargin>
        <FormattedMessage id={headline} />
      </Headline>
      <S.RecruiterInfoCardCopy size="small" sizeWide="medium">
        <FormattedMessage id={copy} />
      </S.RecruiterInfoCardCopy>
    </S.RecruiterInfoCard>
  );
};

type ProJobsUpsellBannerProps = {
  className?: string;
  isBasic?: Maybe<boolean>;
};

export const ProJobsUpsellBanner: React.FC<ProJobsUpsellBannerProps> = ({
  isBasic,
  className,
}) => {
  return (
    <S.ContentBanner className={className} variant="proJobs" display="inline">
      <S.ContentContainer>
        <S.InfoContainer>
          <S.Headline sizeWide="large">
            <FormattedMessage id="JOB_SEARCH_PROJOBS_UPSELL_HEADLINE" />
          </S.Headline>
          <S.RecruiterInfoContainer>
            <RecruiterInfoCard
              headline={
                !isBasic
                  ? 'JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_VISITS_FACTOR'
                  : 'JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_BASIC_VISITS_FACTOR'
              }
              copy="JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_VISITS_TEXT"
            />
            <RecruiterInfoCard
              headline={
                !isBasic
                  ? 'JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_MESSAGES_FACTOR'
                  : 'JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_BASIC_MESSAGES_FACTOR'
              }
              copy="JOB_SEARCH_PROJOBS_UPSELL_RECRUITER_MESSAGES_TEXT"
            />
          </S.RecruiterInfoContainer>
        </S.InfoContainer>
        <S.ButtonContainer>
          <Button
            variant="proJobs"
            size="small"
            sizeWide="medium"
            to="/upsell/pro_jobs_offers?reagent=uplt_963"
          >
            <FormattedMessage id="JOB_SEARCH_PROJOBS_UPSELL_CTA" />
          </Button>
        </S.ButtonContainer>
      </S.ContentContainer>
    </S.ContentBanner>
  );
};
